import { QueryParameters } from "../consts";

/** Opens the survey responses page in a new window (same behavior as legacy top nav). */
export function openViewResponsesWindow(language: string): void {
    let url = window.location.href;

    if (url.includes(`/S2`)) {
        url = url.split(`/S2`)[0] + `/S2/Responses/Index?${QueryParameters.LANGUAGE}=${language}`;
    } else {
        url = `Responses/Index?${QueryParameters.LANGUAGE}=${language}`;
    }

    const psid = document.querySelector<HTMLInputElement>("#S2_SessionId")?.value;
    const skey = document.querySelector<HTMLInputElement>("#S2_SessionId_Skey")?.value;

    if (psid) {
        url += `&${QueryParameters.PAGE_SESSION_ID}=${psid}`;
    }
    if (skey) {
        url += `&${QueryParameters.SESSION_KEY}=${skey}`;
    }

    const win = window.open(url);
    if (win) {
        win.focus();
    }
}
